import React, { Component } from 'react';

import runtimeEnv from '@mars/heroku-js-runtime-env';
const env = runtimeEnv();

class Radison extends Component {
    componentDidMount() {
        window.analytics.page('Home');
    }

    trackEvent(event){
        let event_type = '';
        if(event.target.getAttribute("class").includes("sms")){
            event_type = 'Radisson Red Brussels SMS Button Click';
        } else {
            event_type = 'Radisson Red Brussels Whatsapp Button Click';
        }
        window.analytics.track(event_type, {
            category: 'Landing Page Messaging'
        });

    }

    render() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        let junction = '&';
        if (/android/i.test(userAgent)) {
            junction = '?';
        }
        return (
            <div id="radison">
                <div className="title">Let's Chat</div>
                <div className="body">
                    <div className="description">Get in touch with our new e-concierge for anything you need, such as extra towels, breakfast opening hours or an express check-out. We are here to help you.</div>
                </div>
                <footer>
                    <div className="heading">Tap To Start</div>
                    <div className="links">
                        <a href={env.REACT_APP_SMS_CONTACT + junction + env.REACT_APP_SMS_MESSAGE} className="nav-link" onClick={this.trackEvent}>
                            <div className="icon sms"></div>
                        </a>
                        <a className="nav-link">
                            <div className="seperator"></div>
                        </a>
                        <a href={env.REACT_APP_WHATSAPP_URL} className="nav-link" onClick={this.trackEvent}>
                            <div className="icon whatsapp"></div>
                        </a>
                    </div>
                </footer>
            </div>
        );
    }
};

export default Radison;
